export function has_time(input: string): boolean {
  const timeRegex = /([01]?[0-9]|2[0-3]):[0-5][0-9]/;
  return timeRegex.test(input);
}
export function has_email(input: string): boolean {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(input);
}
export function has_phone(input: string): boolean {
  const phoneRegex = /^(\+\d{2} \d{3} \d{3} \d{3}|\+\d{11}|\d{9})$/;
  return phoneRegex.test(input);
}

export function has_whatsapp(input: string): boolean {
  const whatsappRegex = /^(\+\d{2} \d{3} \d{3} \d{3}|\+\d{11}|\d{9})$/;
  return whatsappRegex.test(input);
}

export function has_address(input: string): boolean {
  return input.includes("C/");
}
